import * as React from "react";
import { useTranslation } from "hooks";
import {
  Checkbox,
  CheckboxGroup,
  CheckboxProvider,
  Typography,
} from "components";
import { FiltersTypes } from "../../duck";
import styles from "./Entities.module.css";

interface EntitiesProps {
  className?: string;
  listClassName?: string;
  labelClassName?: string;
  entitiesCount: FiltersTypes.EntityAssetsCount;
}

const Entities: React.FC<EntitiesProps> = ({
  className,
  listClassName,
  labelClassName,
  entitiesCount,
}) => {
  const { t } = useTranslation();

  const createEntityGroup = (
    name: string,
    label: string,
    data: any[],
  ): React.ReactElement<any> => (
    <CheckboxProvider name={name}>
      {({ indeterminate }) => {
        const filters = data.map((item) => (
          <Checkbox
            key={item.name}
            value={name === "types" ? item.name : item.id}
            label={
              <>
                {item.name}
                <span className={styles.count}>{item.count}</span>
              </>
            }
          />
        ));

        return (
          <CheckboxGroup
            labelClassName={labelClassName}
            listClassName={listClassName}
            label={<Typography variant="label">{label}</Typography>}
            hiddenLabel={label}
          >
            <Checkbox
              checkAll
              label="Select All"
              indeterminate={indeterminate}
            />
            {filters as any}
          </CheckboxGroup>
        );
      }}
    </CheckboxProvider>
  );

  return (
    <div className={className}>
      {createEntityGroup("topics", t("streaming.topics"), entitiesCount.topic)}
      {createEntityGroup("grades", t("streaming.grades"), entitiesCount.grade)}
      {createEntityGroup("types", t("streaming.types"), entitiesCount.type)}
    </div>
  );
};

export default Entities;
